module.exports = __webpack_public_path__ + "static/media/4ofakindonecolor.32aa06af.png";